import { useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
import { CurrencyFormat } from "utils/CurrencyFormat";
import ImgGlasse from "../../../../assets/imgOS.png";
import ActionButton from "../../../Button/ActionButton";
import LayoutDetails from "../../../LayoutModal/LayoutDetails";
import Loading from "../../../Loading";
import * as S from "./style";
import { baseUrlExport } from "services/config";
//components
import Carousel from "../../../../components/Carousel";
import IDetailsOrder from "../../../Modals/Order/Details"
//Icons
import {
  Export,
  DownloadSimple,
  Circle,
  ArrowSquareOut
} from "@phosphor-icons/react";
//hooks
import useLoading from "../../../../hooks/useLoading";
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
//Interface
import { IAttachments, IServiceOrder, IData } from "Interfaces/IServiceOrder";
// utils
import FormatarData from "utils/FormatData";

interface IDetails {
  isOpenModalDetails: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
}

export default function Details({
  isOpenModalDetails,
  setModalClose,
  selectedUrlId,
}: IDetails) {

  const [data, setData] = useState<IData | null>(null);
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [openModalOrderId, setOpenModalOrderId] = useState<number | null>(null);
  const {
    isLoading: isLoadingAtt,
    startLoading: startLoadingAtt,
    stopLoading: stopLoadingAtt
  } = useLoading();

  const [carouselImg, setCarouselImg] = useState<IAttachments[]>([]);

  const listHeadLens = [
    "",
    "Esférico",
    "Cilindro",
    "Eixo",
    "DNP",
    "Altura",
    "Adição",
    "DNP V",
    "ALT",
  ];
  // Array com os nomes dos campos
  const fieldsOE = [
    "spherical_left",
    "cylindrical_left",
    "axis_left",
    "dnp_left",
    "height_left",
    "addition_left",
    "dnp_v_left",
    "alt_left"
  ] as const;

  const fieldsOD = [
    "spherical_right",
    "cylindrical_right",
    "axis_right",
    "dnp_right",
    "height_right",
    "addition_right",
    "dnp_v_right",
    "alt_right"
  ] as const;

  const listHeadLensPonte = [
    "Ponte",
    "Hori. Maior",
    "Vert. Maior",
    "Diag. Maior",
  ];

  const fieldsPonte = [
    "bridge",
    "larger_horizontal",
    "larger_vertical",
    "larger_diagonal"
  ] as const;

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`service-order/${selectedUrlId}`);
      const responseData = response.data;
      setData(response.data);
      setOpenModalOrderId(responseData.saleInfo?.id);
      console.log('data: ', response.data);
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModalDetails && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModalDetails, selectedUrlId]);

  const importData = () => {
    startLoadingAtt();
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = '.png,.jpg,.jpeg,.pdf'; // restringe os tipos

    input.onchange = async () => {
      if (!input.files || input.files.length === 0) {
        stopLoadingAtt();
        return;
      }
      const formData = new FormData();
      Array.from(input.files).forEach((file: File) => {
        formData.append("attachments[]", file);
      });
      formData.append("_method", "PATCH");

      // Verificação dos dados
      formData.forEach((value, key) => {
        if (value instanceof File) {
          console.log(`Arquivo - campo: ${key}`);
          console.log('  Nome:', value.name);
          console.log('  Tipo:', value.type);
          console.log('  Tamanho:', value.size);
        } else {
          console.log(`Outro dado - ${key}:`, value);
        }
      });

      try {
        const response = await axiosInstance.post(
          `service-order/${selectedUrlId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200) {
          fetchData();
        }
      } catch (e: any) {
        alert('Erro ao anexar arquivo');
        console.log(`Erro no arquivo: ${e}`)
      } finally {
        stopLoadingAtt();
      }

    };

    input.click();
  };

  // Funçaõ para exportar arquivo
  const exportData = async () => {
    startLoading();
    try {
      window.open(`${baseUrlExport}${selectedUrlId}`, '_blank');
    } catch (error) {
      alert(`Erro ao exportar dados: ${error}`);
    } finally {
      stopLoading();
    }
  };

  // Função para ir para modal Carousel
  const dataCarousel = (attachments: IServiceOrder['service_order_attachments']) => {
    setCarouselImg(attachments); // atualiza o estado
    toggleModalVisibility('open-carousel'); // abre o modal
  };

  if (isOpenModalDetails) {
    return (
      <LayoutDetails
        title="Detalhes da Ordem de Serviço"
        subTitle="Veja todos os detalhes disponíveis sobre a O.S."
        setModalClose={setModalClose}
      >
        {isLoading || !data ? ( // Se estiver carregando ou os dados forem nulos, mostra o loading
          <Loading />
        ) : (
          <S.Content>
            <S.Infor>
              <S.Status>
                <Circle size={8} weight="fill" />
                {data.serviceOrder?.sale?.status || "-"}
              </S.Status>
            </S.Infor>
            <S.Header>
              <S.ContentImage>
                <S.Image src={ImgGlasse} alt="Imagem Óculos" />
              </S.ContentImage>
              <S.ContentInfor>
                <S.Infor>
                  <p>Número da O.S:</p>
                  <span>{data.serviceOrder?.number_os || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Número da Venda:</p>
                  <span>{data.serviceOrder?.sale?.number_ata || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Total:</p>
                  <span>
                    {CurrencyFormat(parseFloat(data.serviceOrder?.sale?.total_amount || "0"))}
                  </span>
                </S.Infor>
                <S.Infor>
                  <p>Data da Entrega:</p>
                  <span>
                    {FormatarData(data.serviceOrder?.delivery, 'default-data')}
                  </span>
                </S.Infor>
              </S.ContentInfor>
            </S.Header>

            <S.Body>
              {/* Informações do Cliente e vendedor */}
              <S.Section>
                <S.ContentBody>
                  <S.InforBody>
                    <p>Cliente</p>
                    <span>
                      {data.serviceOrder?.sale?.customer?.full_name || "-"}
                    </span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>E-mail</p>
                    <span>
                      {data.serviceOrder?.sale?.customer?.email || "-"}
                    </span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Vendedor</p>
                    <span>{data.serviceOrder?.sale?.seller?.first_name || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>RG/CPF</p>
                    <span>
                      {data.serviceOrder?.sale?.customer?.rg || "-"}
                      /
                      {data.serviceOrder?.sale?.customer?.cpf || "-"}
                    </span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Nº Convênio</p>
                    <span>{data.serviceOrder?.sale?.customer?.number_agreement || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>
              </S.Section>

              {/* table */}
              <S.ContainerTable>
                <S.Table>
                  <S.Thead>
                    <S.Tr>
                      {listHeadLens.map((header) => {
                        return <th>{header}</th>;
                      })}
                    </S.Tr>
                  </S.Thead>

                  <S.Tbody>
                    <S.Tr>
                      <S.Td>OD</S.Td>
                      {
                        fieldsOD.map((fieldName, index) => (
                          <S.Td key={index}>
                            {data.serviceOrder?.[fieldName] || '-'}
                          </S.Td>
                        ))
                      }
                    </S.Tr>

                    <S.Tr>
                      <S.Td>OE</S.Td>
                      {
                        fieldsOE.map((fieldName, index) => (
                          <S.Td key={index}>
                            {data.serviceOrder?.[fieldName] || '-'}
                          </S.Td>
                        ))
                      }
                    </S.Tr>
                  </S.Tbody>
                </S.Table>

                <S.Table>
                  <S.Thead>
                    <S.Tr>
                      {listHeadLensPonte.map((header) => {
                        return <th>{header}</th>;
                      })}
                    </S.Tr>
                  </S.Thead>

                  <S.Tbody>
                    <S.Tr>
                      {
                        fieldsPonte.map((fieldName, index) => (
                          <S.Td key={index}>
                            {data.serviceOrder?.[fieldName]}
                          </S.Td>
                        ))
                      }
                    </S.Tr>
                  </S.Tbody>
                </S.Table>
              </S.ContainerTable>

              {/* Sessão de valores */}
              <S.FeaturedSection>
                <S.InforBody>
                  <p>Subtotal da Compra</p>
                  <span>
                    {data.financialSummary?.subtotal || "0"}
                  </span>
                </S.InforBody>

                <S.InforBody>
                  <p>Total de Desconto</p>
                  <span>
                    {data.financialSummary?.total_discounts || "0"}
                  </span>
                </S.InforBody>

                <S.InforBody>
                  <p>Total da Compra</p>
                  <span>
                    {data.financialSummary?.total_amount || "0"}
                  </span>
                </S.InforBody>
              </S.FeaturedSection>

              <S.FeaturedSection>
                <S.InforBody>
                  <S.Text>
                    Itens da Venda
                    <S.Button onClick={() => toggleModalVisibility("details")}>
                      Ver mais
                      <ArrowSquareOut size={14} />
                    </S.Button>
                  </S.Text>
                  {data.items.map((item, index) => (
                    <span>
                      {item.quantity}x {item.product.name} {item.total}
                    </span>
                  ))}
                </S.InforBody>
              </S.FeaturedSection>

              <S.InforBody>
                <p>Observação</p>
                <S.Description>{data.serviceOrder?.observation || "-"}</S.Description>
              </S.InforBody>

              {
                data.attachments.length > 0 &&
                <S.InforBody>
                  <p>Anexos</p>
                  <div>
                    <S.Button
                      onClick={() => dataCarousel(data.attachments)}
                    >
                      Visualizar
                    </S.Button>
                  </div>
                </S.InforBody>
              }

              {/* Informação de Data do cadastro */}
              <S.InforBody>
                <S.InforSmall>Cadastrado em: {
                  FormatarData(data.serviceOrder?.created_at || "-")
                }</S.InforSmall>
                <S.InforSmall>Ultima atualização em: {
                  FormatarData(data.serviceOrder?.updated_at) || "-"
                }</S.InforSmall>
              </S.InforBody>

              <S.ContentButton>
                <ActionButton
                  Icon={<DownloadSimple size={24} />}
                  name={isLoadingAtt ? 'Carregando...' : 'Anexar  O.S'}
                  onClick={importData}
                />
                <ActionButton
                  Icon={<Export size={24} />}
                  name={'Exportar O.S'}
                  onClick={exportData}
                />
              </S.ContentButton>
            </S.Body>
          </S.Content>
        )}

        <Carousel
          isOpenCarousel={isOpenModal('open-carousel')}
          setOpenCarousel={() => toggleModalVisibility('open-carousel')}
          attachments={carouselImg}
          refreshData={fetchData}
        />

        <IDetailsOrder
          isOpenModalDetails={isOpenModal("details")}
          setModalClose={() => toggleModalVisibility("details")}
          selectedUrlId={openModalOrderId}
        />
      </LayoutDetails>
    );
  }
  return null;
}
